import { Action } from '@ngrx/store';

export enum CheckInFeatureActionTypes {
  CheckIn = '[CheckIn] Check In',
  CheckInSuccess = '[CheckIn] Check In Success',
  CheckInFailure = '[CheckIn] Check In Failure',
}

export class CheckIn implements Action {
  readonly type = CheckInFeatureActionTypes.CheckIn;

  constructor(public payload: any) {}
}

export class CheckInSuccess implements Action {
  readonly type = CheckInFeatureActionTypes.CheckInSuccess;
}

export class CheckInFailure implements Action {
  readonly type = CheckInFeatureActionTypes.CheckInFailure;

  constructor(public payload?: { errorCode: string }) {}
}

export type CheckInFeatureActions = CheckIn;
